// extracted by mini-css-extract-plugin
export default {"root":"header-table_root__gRXK7","item":"header-table_item__8gm6P"};